export default {
  'NoteMediaFiles.MultipleFilesWrapper.Image': ({ url, content_type }, outlet) => {
    outlet({ url, content_type })
  },
  'NoteMediaFiles.MultipleFilesWrapper.MoreImages': ({ url, content_type }, outlet) => {
    outlet({ url, content_type })
  },
  'NoteMediaFiles.MultipleFilesWrapper.MoreImages.Image': ({ url, content_type }, outlet) => {
    outlet({ url, content_type })
  },
  'NoteMediaFiles.Image': ({ url, content_type }, outlet) => {
    outlet({ url, content_type })
  },
}